/**
 * AgentBadgeApiClient -- HTTP client for /api/v1/agent-badges.
 * CRUD for agent badges (validated capabilities).
 *
 * @module infrastructure/api/AgentBadgeApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/agent-badges';

export const AgentBadgeApiClient = {
  async list({ agentCode, domain, sortBy = 'unlockedAt', sortOrder = 'desc', page = 1, pageSize = 50 } = {}) {
    const params = new URLSearchParams();
    if (agentCode) params.set('agentCode', agentCode);
    if (domain) params.set('domain', domain);
    params.set('sortBy', sortBy);
    params.set('sortOrder', sortOrder);
    params.set('page', page);
    params.set('pageSize', pageSize);
    return ApiBase.get(`${BASE}?${params}`);
  },

  async getById(id) {
    return ApiBase.get(`${BASE}/${id}`);
  },

  async create(data) {
    return ApiBase.post(BASE, data);
  },

  async update(id, data) {
    return ApiBase.put(`${BASE}/${id}`, data);
  },

  async remove(id) {
    return ApiBase.del(`${BASE}/${id}`);
  }
};
